module.exports = __webpack_public_path__ + "static/media/css.6827470e.svg";